import { Select, DatePicker, Input, Form, Row, Col } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { leaveTypesArray } from "../../../commons/Arrays/LeavesTypesArray";
import { isAuthenticated } from "../../../commons/Auth/auth";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import { Error, Success } from "../../../commons/Messages/Messages";
import { SocketContext } from "../../../context/SocketContext";
import { sendLeave } from "../../../commons/Appointments/appointmentApi";
import GeneralModal from "../../../serviceProvider/components/General.modal";
import dayjs from "dayjs";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;

const UpdateLeaves = ({ disabled, data, updateParent, serviceProvider }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const socket = useContext(SocketContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        leaveType: data?.leaveType,
        paidStatus: data?.paidStatus,
        status: data?.status,
        startDate: data?.startDate ? dayjs(data.startDate) : null,
        endDate: data?.endDate ? dayjs(data.endDate) : null,
        reason: data?.reason,
        note: data?.note
      });
    }
  }, [data, form]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = async values => {
    try {
      const payload = {
        ...values,
        startDate: values.startDate ? values.startDate.toISOString() : null,
        endDate: values.endDate ? values.endDate.toISOString() : null
      };

      const res = await sendLeave("put", `/update/${data?._id}`, payload, t);
      if (!res) return; // kept "Cancel" in the appointments dialog

      if (res.status === 200 || res.status === 304) {
        Success(res.data.successMessage);
        updateParent();
        handleCancel();
        socket.emit("refresh service provider data", {
          user: isAuthenticated()?.serviceProviderId
        });
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      if (err?.response?.data?.errors) {
        const validationErrors = err.response.data.errors;
        const errorMessage = Object.values(validationErrors)
          .map(err => `${err.path} is ${err.kind}.`)
          .join("\n");
        Error(errorMessage);
      } else if (err?.response?.data?.errorMessage) {
        Error(err?.response?.data?.errorMessage);
      } else {
        Error(err.message);
      }
    }
  };

  return (
    <div className="UpdateLeaves">
      <MainButtonComp disabled={disabled && "Disabled"} text="Edit" editBtn onClick={showModal} />
      <GeneralModal
        title={t("Update Leaves")}
        onOk={() => form.submit()}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        items={[
          {
            key: "1",
            label: t("Leaves"),
            children: (
              <Form form={form} layout="vertical" onFinish={onSubmit}>
                <Form.Item
                  name="leaveType"
                  label={t("Leave Type")}
                  rules={[{ required: true, message: t("Please select a leave type") }]}
                >
                  <Select
                    className="w-100"
                    options={leaveTypesArray}
                    placeholder={t("Select Leave Type")}
                  />
                </Form.Item>
                {!serviceProvider && (
                  <Form.Item name="paidStatus" label={t("Paid Status")}>
                    <Select
                      className="w-100"
                      options={[
                        { label: t("Paid"), value: true },
                        { label: t("Unpaid"), value: false }
                      ]}
                      placeholder={t("Select Leave Paid Status")}
                    />
                  </Form.Item>
                )}
                <Row gutter={[16, 0]}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="startDate"
                      label={t("Leave Start Date")}
                      rules={[{ required: true, message: t("Please select a start date") }]}
                    >
                      <DatePicker format="DD/MMM/YYYY" className="w-100" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="endDate"
                      label={t("Leave End Date")}
                      rules={[{ required: true, message: t("Please select an end date") }]}
                    >
                      <DatePicker format="DD/MMM/YYYY" className="w-100" />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item name="reason" label={t("Reason")}>
                  <TextArea rows={4} className="w-100" />
                </Form.Item>

                <Form.Item name="note" label={t("Note")}>
                  <TextArea rows={2} className="w-100" />
                </Form.Item>

                {serviceProvider && (
                  <>
                    <Form.Item name="status" label={t("Leave Status")}>
                      <Select
                        className="w-100"
                        options={[
                          { label: t("Pending"), value: "Pending" },
                          { label: t("Approved"), value: "Approved" },
                          { label: t("Rejected"), value: "Rejected" }
                        ]}
                        placeholder={t("Select Leave Status")}
                      />
                    </Form.Item>

                    <Form.Item name="paidStatus" label={t("Paid Status")}>
                      <Select
                        className="w-100"
                        options={[
                          { label: t("Paid"), value: true },
                          { label: t("Unpaid"), value: false }
                        ]}
                        placeholder={t("Select Leave Paid Status")}
                      />
                    </Form.Item>
                  </>
                )}
              </Form>
            )
          }
        ]}
      />
    </div>
  );
};

export default UpdateLeaves;
